import { render, staticRenderFns } from "./ActionValidateRouterProduct.vue?vue&type=template&id=b3fee20e&scoped=true&"
import script from "./ActionValidateRouterProduct.vue?vue&type=script&lang=js&"
export * from "./ActionValidateRouterProduct.vue?vue&type=script&lang=js&"
import style0 from "./ActionValidateRouterProduct.vue?vue&type=style&index=0&id=b3fee20e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fee20e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
